module.exports = __webpack_public_path__ + "img/yellowcaution.1ec497aa.svg";